// extracted by mini-css-extract-plugin
export default {"tableHead":"style_tableHead__4yBUr","customRadioStyle":"style_customRadioStyle__QIN1L","stickyHeader":"style_stickyHeader__gqqNG"};